import React from 'react';
import './styles.scss';

const ContentWrapper = ({ children }) => <div className="content-wrapper-1024">{children}</div>;

export default ContentWrapper;
